import { FormGroup } from "@angular/forms";
import { Location } from '@angular/common';
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthUserService } from "../../../services/auth-user.service";
import { RegistrationFormService } from "../../../services/data/registration-form.service";
import { ConfirmModalService } from "../../../components/confirm-modal/confirm-modal.service";

@Component({ template: '' })
export abstract class ApprovedPageBaseComponent {
    public authUserService = inject(AuthUserService)

    private _route = inject(ActivatedRoute)
    private _location = inject(Location)
    private _formService = inject(RegistrationFormService)

    protected formId!: string;
    protected model: any = {};
    protected origModel: any = {};

    protected form = new FormGroup({});
    protected fields: FormlyFieldConfig[] = [];
    protected options: FormlyFormOptions = {
        formState: {
            disabled: true
        }
    };

    ngOnInit(): void {
        this.formId = this._route.snapshot.paramMap.get('id')!;
        this.load();
    }

    back() {
        this._location.back();
    }

    private load() {
        this._formService.getForm(this.formId).subscribe({
            next: (data) => {
                this.model = data;
            }
        })
    }
}